<template>
  <ol class="breadcrumb">
    <li v-for="item in categories" :key="item.id" class="breadcrumb-item">
      <router-link :to="{ name: 'Category', params: { categoryId: item.id }}"> {{ item.id === 1 ? "All Categories" : item.name }}</router-link>
    </li>
  </ol>
</template>

<script>

import { mapState } from 'vuex'

export default {
  data () {
    return {}
  },
  computed: {
    ...mapState({
      categories: state => state.category.parents,
    }),
  },
  methods: {},
  created () { }
}
</script>

<style lang="scss">
</style>
